import me from '../static/img/me.png'

const About = () => {

  const scrollIntoContact = () =>{
    document.getElementById("contact-info").scrollIntoView();
  }

  return (
    <section
      id="about"
      data-nav-tooltip="About"
      className="pp-section pp-scrollable section counter"
    >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 m-15px-tb">
            <div className="about-me">
              <div className="img">
                <div className="img-in">
                  <img src={me} title="" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 m-15px-tb">
            <div className="about-info">
              <div className="title">
                <h3>Sobre mi.</h3>
              </div>
              <div className="about-text">
                <h3>
                Soy un desarrollador FullStack con un año de experiencia.
                </h3>
                <p>
                Trabajo con tecnologías como JavaScript, TypeScript, PHP, CodeIgniter y Python, entre otras, siempre enfocado en cumplir las expectativas del cliente. Además de mi labor en el desarrollo, soy Entrenador Personal e Instructor de Fitness Grupal, siendo TribeCoach y presentador nacional de BODYCOMBAT en mi país. Busco perfeccionarme constantemente como desarrollador, encontrando inspiración en el aprendizaje continuo y la magia de la programación para crear soluciones impactantes.
                </p>
                <div className="btn-bar">
                  <button className="px-btn px-btn-theme" style={{ cursor: 'pointer' }} onClick={() => scrollIntoContact()}>
                    <span>Contáctame</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="separated" />

    </section>
  );
};
export default About;
